import { render, staticRenderFns } from "./WeeklyPlayable.vue?vue&type=template&id=481d6024&scoped=true&"
import script from "./WeeklyPlayable.vue?vue&type=script&lang=js&"
export * from "./WeeklyPlayable.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyPlayable.vue?vue&type=style&index=0&id=481d6024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d6024",
  null
  
)

export default component.exports